import { _ as __vitePreload } from 'theme/preload-helper';
import 'theme/vendor';
import 'theme/vendor-helpers';


const SELECTOR = '.btn:not(:disabled):not(.disabled):not([aria-disabled="true"])';

function setOrigin(circle, e, btn) {
  const rect = btn.getBoundingClientRect();
  const x = ((e.clientX - rect.left) / rect.width) * 100;
  const y = ((e.clientY - rect.top) / rect.height) * 100;
  circle.style.transformOrigin = `${x}% ${y}%`;
}

document.addEventListener('mouseover', (e) => {
  const btn = e.target.closest(SELECTOR);
  if (!btn || btn._hovered) return;
  btn._hovered = true;

  const circle = btn.querySelector('.btn__circle');
  if (!circle) return;

  setOrigin(circle, e, btn);
});

document.addEventListener('mouseout', (e) => {
  const btn = e.target.closest(SELECTOR);
  if (!btn || !btn._hovered) return;
  if (btn.contains(e.relatedTarget)) return;

  btn._hovered = false;

  const circle = btn.querySelector('.btn__circle');
  if (!circle) return;

  setOrigin(circle, e, btn);
});

if (!window.Shopify?.designMode) __vitePreload(() => import('theme/vendor').then(n => n.i),true              ?[]:void 0,import.meta.url);

let _headerObserver = null;
const _observeHeader = () => {
  _headerObserver?.disconnect();
  _headerObserver = null;
  const header = document.querySelector('header');
  if (!header) return;
  const setHeaderHeight = () =>
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  setHeaderHeight();
  _headerObserver = new ResizeObserver(setHeaderHeight);
  _headerObserver.observe(header);
};
_observeHeader();
document.addEventListener('shopify:section:load', _observeHeader);
